module.exports = "<app-cutting_table></app-cutting_table>\n"